'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var convertKmToMeters = exports.convertKmToMeters = function convertKmToMeters(data) {
  return data * 1000;
};
var convertMilesToMeters = exports.convertMilesToMeters = function convertMilesToMeters(data) {
  return data * 1609.344;
};
var convertFeetToMeters = exports.convertFeetToMeters = function convertFeetToMeters(data) {
  return data * 0.3048;
};

var convertMetersToKm = exports.convertMetersToKm = function convertMetersToKm(data) {
  return data / 1000;
};
var convertMetersToMiles = exports.convertMetersToMiles = function convertMetersToMiles(data) {
  return data * 0.000621371;
};
var convertMetersToFeet = exports.convertMetersToFeet = function convertMetersToFeet(data) {
  return data * 3.28084;
};

var convertMetersToUnit = exports.convertMetersToUnit = function convertMetersToUnit(amount, unit) {
  if (isNaN(amount)) {
    return 0;
  }

  switch (unit) {
    case 'km':
    case 'kilometers':
    case 'kilometres':
      return convertMetersToKm(amount);
    case 'mi':
    case 'miles':
      return convertMetersToMiles(amount);
    case 'ft':
    case 'feet':
      return convertMetersToFeet(amount);
    default:
      return Number(amount);
  }
};

var convertToMeters = exports.convertToMeters = function convertToMeters(amount) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'm';

  if (isNaN(amount)) {
    return 0;
  }

  switch (unit) {
    case 'km':
    case 'kilometers':
    case 'kilometres':
      return convertKmToMeters(amount);
    case 'mi':
    case 'miles':
      return convertMilesToMeters(amount);
    case 'ft':
    case 'feet':
      return convertFeetToMeters(amount);
    default:
      return Number(amount);
  }
};

var convertToSeconds = exports.convertToSeconds = function convertToSeconds(amount) {
  var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'seconds';

  if (isNaN(amount)) {
    return 0;
  }

  switch (unit) {
    case 'day':
    case 'days':
      return amount * 86400;
    case 'hr':
    case 'hrs':
    case 'hour':
    case 'hours':
      return amount * 3600;
    case 'min':
    case 'minute':
    case 'minutes':
      return amount * 60;
    default:
      return Number(amount);
  }
};